var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BehaviorSubject } from 'rxjs';
var BehaviorStore = /** @class */ (function () {
    function BehaviorStore(initialState) {
        this.state$ = new BehaviorSubject(initialState);
    }
    Object.defineProperty(BehaviorStore.prototype, "state", {
        get: function () {
            return this.state$.value;
        },
        enumerable: true,
        configurable: true
    });
    BehaviorStore.prototype.setState = function (stateUpdate) {
        this.state$.next(this._applyStateUpdater(this.state, stateUpdate));
    };
    BehaviorStore.prototype._applyStateUpdater = function (state, stateUpdate) {
        if (typeof stateUpdate === 'function') {
            return __assign({}, state, stateUpdate(state));
        }
        else {
            return __assign({}, state, stateUpdate);
        }
    };
    return BehaviorStore;
}());
export { BehaviorStore };
//# sourceMappingURL=BehaviorStore.js.map